import { areaActions } from '../actions'

const { FETCH_AREAS, FETCHING_AREAS, FETCH_AREAS_ERROR } = areaActions

const initialState = {
  items: [],
  loading: false,
  error: ''
}

const areas = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCH_AREAS:
      return { 
        ...state,
        items: action.items, 
        loading: false, 
        error: ''
      }
    case FETCHING_AREAS:
      return { 
        ...state, 
        items: [], 
        loading: true, 
        error: ''
      }
    case FETCH_AREAS_ERROR:
      return { 
        ...state, 
        items: [], 
        loading: false, 
        error: action.error
      }
    default:
      return state
  }
}

export default areas



// WEBPACK FOOTER //
// ./src/reducers/area.js